import { render, staticRenderFns } from "./AgencyInvoicing.vue?vue&type=template&id=572b9b0d&scoped=true&"
import script from "./AgencyInvoicing.vue?vue&type=script&lang=ts&"
export * from "./AgencyInvoicing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572b9b0d",
  null
  
)

export default component.exports